import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { InputSwitch } from "primereact/inputswitch";

const Switch = ({ name, control, getFormErrorMessage, checked: externalChecked, onChange }) => {
  const [checked, setChecked] = useState(externalChecked);

  const handleSwitchChange = () => {
    setChecked((prevChecked) => !prevChecked);
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <>
          <label htmlFor={field.name}></label>
          <InputSwitch
            inputId={field.name}
            checked={checked}
            inputRef={field.ref}
            className={classNames({ "p-invalid": fieldState.error })}
            onChange={(e) => {
              field.onChange(e.value);
              onChange && onChange(e.target.value);
              handleSwitchChange();
            }}
          />
          {getFormErrorMessage(field.name)}
        </>
      )}
    />
  );
};

export default Switch;
